import React, { useState, useEffect, useRef, useCallback } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Grid, Button } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import { fetchShipments } from "../../api/shipmentTable";
import { useTheme } from "@mui/material/styles";
import config from "../../api/config";
import InfiniteScroll from "react-infinite-scroll-component";
import { useToastContext } from "../../context/toast";
import NotesField from "../Reusables/Note";
import {
	formatDeliveryStatus,
	formatMultipleValues,
	getMissedRowBackground,
	getLocalTime,
	removeDuplicateShipments,
} from "../../utilities/shipmentTable";
import { EditIcon } from "../Reusables/icons";
import { SimpleEditDailog } from "../simple-edit-dailog/simple-edit-dailog";
import { updateShipment } from "../../api/updateShipmentTable";
import { useUserContext } from "../../context/UserContext";
import TruncatedText from "../../utilities/TruncatedText";
import { getDisplayRegion } from "../../utilities/shipmentTable";

function Row(props) {
	const { row, index, columns, handleCustNotesSubmit } = props;
	const [open, setOpen] = useState(false);
	const [isCustNotesEdit, setIsCustNotesEdit] = useState(false);
	const theme = useTheme();

	const missedRowBg = getMissedRowBackground(row);

	const onSubmitCustNotes = async (customerNotes) => {
		await handleCustNotesSubmit(row, customerNotes);
	};

	return (
		<>
			<TableRow
				sx={{
					"& > *": {
						backgroundColor: missedRowBg ? missedRowBg : theme.palette.primary.secondary,
					},
				}}
			>
				{columns.map((column, columnIndex) => {
					const isFirstColumn = columnIndex === 0;
					return (
						<TableCell
							key={column.id}
							sx={{
								width: column.width,
								padding: "0",
								textAlign: "left",
								whiteSpace: "nowrap",
								overflow: "hidden",
								fontSize: "12px",
							}}
						>
							{isFirstColumn ? (
								<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
									<IconButton
										size="small"
										onClick={() => setOpen(!open)}
										sx={{ marginRight: "8px", padding: "0px" }}
									>
										{open ? (
											<KeyboardArrowUpIcon fontSize="small" />
										) : (
											<KeyboardArrowDownIcon fontSize="small" />
										)}
									</IconButton>
									<span style={{ minWidth: "100px", textAlign: "left" }}>
										{formatMultipleValues(row?.WareHouseNbr)}
									</span>
								</Box>
							) : column.id === "WareHouseNbr" ? (
								<TruncatedText text={row?.ShipmentDetails?.WareHouseNbr} />
							) : column.id === "City" ? (
								<TruncatedText text={row?.City} />
							) : column.id === "State" ? (
								<TruncatedText text={row?.State} />
							) : column.id === "PONumber" ? (
								<TruncatedText text={row?.ShipmentDetails?.PONumber} />
							) : column.id === "DeliveryAppointment" ? (
								<TruncatedText
									text={
										row.DeliveryAppointment
											? moment(row.DeliveryAppointment, "YYYYMMDDHHmmss").format("MM/DD/YYYY HH:mm")
											: ""
									}
								/>
							) : column.id === "DeliveryStatus" ? (
								<TruncatedText text={formatDeliveryStatus(row?.DeliveryStatus)} />
							) : column.id === "DeliveryEta" ? (
								<TruncatedText
									text={
										row.DeliveryEta
											? moment(row.DeliveryEta, "YYYYMMDDHHmmss").format("MM/DD/YYYY HH:mm")
											: ""
									}
								/>
							) : column.id === "RescheduleDate" ? (
								<TruncatedText
									text={
										row?.RescheduleDate
											? moment(row.RescheduleDate, "YYYYMMDDHHmmss").format("MM/DD/YYYY HH:mm")
											: ""
									}
								/>
							) : column.id === "Comment" ? (
								<TruncatedText text={row?.Comment || ""} />
							) : column.id === "Notes" ? (
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<TruncatedText text={row?.ShipmentDetails?.customerNotes} />
									<EditIcon
										handleClick={() => setIsCustNotesEdit(true)}
										isDarkMode={theme.palette.mode === "dark"}
									/>
								</Box>
							) : null}
						</TableCell>
					);
				})}
			</TableRow>
			<TableRow
				sx={{
					"& > *": {
						backgroundColor: missedRowBg ? missedRowBg : theme.palette.secondary.main,
					},
				}}
			>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={columns.length}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box
							sx={{
								marginLeft: "200px",
								marginTop: "20px",
								paddingBottom: "16px",
								borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
							}}
						>
							<Grid container spacing={2}>
								{[
									["Notes", row?.Notes || ""],
									["Delivery No.", row.DeliveryNumber || ""],
									["Customer Region", getDisplayRegion(row?.ShipmentDetails?.CustomerRegion)],
									["Source", row?.ShipmentDetails?.OrgName || ""],
									["Transit Time", row?.ShipmentDetails?.TransitTime || ""],
								].map(([title, value]) => (
									<Grid item xs={12} sm={6} md={5} lg={3} key={title}>
										<Box
											sx={{
												width: "100%",
												boxSizing: "border-box",
												marginBottom: "8px",
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												justifyContent: "center",
											}}
										>
											<Typography
												sx={{
													fontWeight: 500,
													fontFamily: "Poppins, sans-serif",
													fontSize: "13px",
													lineHeight: "24px",
													textAlign: "left",
													whiteSpace: "normal",
													wordBreak: "break-word",
													verticalAlign: "top",
													display: "flex",
													alignItems: "center",
												}}
											>
												<span>{title}</span>
												{title === "Customer Notes" && (
													<EditIcon
														handleClick={() => setIsCustNotesEdit(true)}
														isDarkMode={theme.palette.mode === "dark"}
													/>
												)}
											</Typography>

											<Typography
												sx={{
													fontFamily: "Poppins, sans-serif",
													fontSize: "13px",
													fontWeight: 400,
													lineHeight: "24px",
													letterSpacing: "0.5px",
													textAlign: "left",
													whiteSpace: "normal",
													wordBreak: "break-word",
													verticalAlign: "top",
												}}
											>
												{["Delivery ETA", "Reschedule Date"].includes(title)
													? value
														? moment(value, "YYYYMMDDHHmmss").format("MM/DD/YYYY HH:mm:ss")
														: ""
													: value}
											</Typography>
										</Box>
									</Grid>
								))}
							</Grid>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
			{isCustNotesEdit && (
				<SimpleEditDailog
					inpValue={row?.ShipmentDetails?.customerNotes || ""}
					handleSubmit={onSubmitCustNotes}
					handleClose={setIsCustNotesEdit}
					title={"Add Notes"}
				/>
			)}
		</>
	);
}

export default function CollapsibleTable({
	isSearchAction,
	appliedFilters,
	onRowsChange,
	onTotalCountChange,
	accountInfo,
	onFetchError,
	availableDates,
}) {
	const [rows, setRows] = useState([]);
	const [error, setError] = useState(null);
	const [sortBy, setSortBy] = useState(null);
	const [sortOrder, setSortOrder] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isSorting, setIsSorting] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(1);
	const [totalCount, setTotalCount] = useState(0);
	const [allFetchedRows, setAllFetchedRows] = useState([]);
	const theme = useTheme();
	const isInitialMount = useRef(true);
	const { showErrorToast } = useToastContext();
	const { userDetails } = useUserContext();

	const fetchData = useCallback(
		async (isInitialFetch = false) => {
			if (!hasMore && !isInitialFetch) return;
			try {
				setIsLoading(true);
				const filters = appliedFilters || {};
				const data = await fetchShipments(
					filters,
					sortBy,
					sortOrder,
					isInitialFetch ? 1 : page,
					availableDates,
					isSearchAction,
					userDetails,
				);

				onFetchError(false);
				setRows((prevRows) => {
					// If it's an initial fetch, just use the new data
					if (isInitialFetch) {
						const uniqueShipments = removeDuplicateShipments(data.shipments);
						setAllFetchedRows(uniqueShipments);
						onRowsChange(uniqueShipments);
						return uniqueShipments;
					}

					// For subsequent fetches, combine with existing data and deduplicate
					const combinedShipments = [...prevRows, ...data.shipments];
					const uniqueShipments = removeDuplicateShipments(combinedShipments);
					setAllFetchedRows(uniqueShipments);
					onRowsChange(uniqueShipments);
					return uniqueShipments;
				});

				//         // Check for invalid warehouse numbers in the response
				//    if (data.invalidWarehouseNumbers && data.invalidWarehouseNumbers.length > 0) {
				//     //  showErrorToast(`Invalid warehouse numbers: ${data.invalidWarehouseNumbers.join(', ')}`)
				//      showErrorToast("Enter valid Warehouse(s)")
				//     }

				setHasMore(data.hasMore);
				setPage(data.nextPage);
				setError(null);
				setTotalCount(data.totalCount);
				onTotalCountChange && onTotalCountChange(data.totalCount);
			} catch (error) {
				console.error("Error fetching shipments:", error);
				// if (error.response) {
				//     if (error.response.data) {
				//       if (Array.isArray(error.response.data.invalidWarehouseNumbers) && error.response.data.invalidWarehouseNumbers.length > 0) {
				//         showErrorToast("Enter valid Warehouse(s)");
				//       } else if (typeof error.response.data.invalidWarehouseNumbers === 'string' && error.response.data.invalidWarehouseNumbers.length > 0) {
				//         showErrorToast("Enter valid Warehouse(s)");
				//       }
				//     }
				//   }
				onFetchError(true);
				setError(
					error.response?.status === 404
						? "No shipments are available"
						: "Failed to fetch shipments",
				);
				setHasMore(false);
			} finally {
				setIsLoading(false);
				setIsSorting(false);
			}
		},
		[appliedFilters, sortBy, sortOrder, page, hasMore, accountInfo], // Add accountInfo to dependencies
	);

	const handleCustNotesSubmit = async (rowData, updatedCustomerNotes) => {
		const updatedRowsData = rows.map((prevRow) =>
			prevRow.NBNumber === rowData.NBNumber
				? {
						...rowData,
						ShipmentDetails: {
							...rowData.ShipmentDetails,
							customerNotes: updatedCustomerNotes,
						},
					}
				: prevRow,
		);

		const payload = {
			DeliveryNumber: rowData?.DeliveryNumber || "",
			NBNumber: rowData?.NBNumber || "",
			customerNotes: updatedCustomerNotes?.trim() || "",
			StopSequence: rowData?.StopSequence ? rowData.StopSequence.toString() : "",
			User: accountInfo?.account?.name || "",
			clientTime: getLocalTime(),
		};
		await updateShipment(payload);
		setRows(updatedRowsData);
	};

	useEffect(() => {
		if (appliedFilters || sortBy || sortOrder) {
			setRows([]);
			setPage(1);
			setHasMore(true);
			setTotalCount(0);
			setError(null);
			fetchData(true);
		}
	}, [appliedFilters, sortBy, sortOrder]);

	useEffect(() => {
		const ws = new WebSocket(config.websocketURL, [userDetails.userIdToken]);

		ws.onopen = () => {
			console.log("Connected to WebSocket server");
		};

		ws.onmessage = (event) => {
			const receivedData = JSON.parse(event.data);

			if (Array.isArray(receivedData)) {
				setError(null);
				setRows((prevRows) => {
					let updatedRows = [...prevRows];

					receivedData.forEach((incomingData) => {
						const existingRowIndex = updatedRows.findIndex(
							(row) =>
								row.DeliveryNumber === incomingData.DeliveryNumber &&
								row.NBNumber === incomingData.NBNumber &&
								// RM/transfer trackers have no StopSequence; match on NBNumber+DeliveryNumber alone.
								((!row.StopSequence && !incomingData.StopSequence) ||
									row.StopSequence === incomingData.StopSequence),
						);

						if (existingRowIndex !== -1) {
							// Update existing row
							updatedRows[existingRowIndex] = {
								...updatedRows[existingRowIndex],
								...incomingData,
								ShipmentDetails: incomingData.ShipmentDetails,
							};
						} else {
							// Add new row
							updatedRows.push(incomingData);
						}
					});

					return updatedRows;
				});
			}
		};

		ws.onerror = (error) => {
			console.error("WebSocket error:", error);
		};

		return () => {
			ws.close();
		};
	}, []);

	const handleSort = useCallback(
		(columnId) => {
			if (isSorting) return;
			setIsSorting(true);
			if (sortBy === columnId) {
				setSortOrder(sortOrder === "ascending" ? "descending" : "ascending");
			} else {
				setSortBy(columnId);
				setSortOrder("ascending");
			}
		},
		[sortBy, sortOrder, isSorting],
	);

	const columns = [
		{ id: "WareHouseNbr", label: "Warehouse", width: "9%", sortable: true },
		{ id: "City", label: "City", width: "9%", sortable: false },
		{ id: "State", label: "State", width: "6%", sortable: false },
		{ id: "PONumber", label: "PO Number", width: "9%", sortable: true },
		{ id: "DeliveryAppointment", label: "Delivery Appointment", width: "9%", sortable: true },
		{ id: "DeliveryEta", label: "Delivery ETA", width: "9%", sortable: true },
		{ id: "DeliveryStatus", label: "Delivery Status", width: "9%", sortable: true },
		{ id: "RescheduleDate", label: "Reschedule Date", width: "9%", sortable: true },
		{ id: "Comment", label: "Comment", width: "9%", sortable: false },
		{ id: "Notes", label: "Customer Notes", width: "9%", sortable: false },
	];

	return (
		<Paper
			sx={{
				// width: "100%",
				overflow: "hidden",
				margin: "20px",
				marginBottom: 0,
				display: "flex",
				flexDirection: "column",
				flex: 1,
				minHeight: 0,
			}}
		>
			{error ? (
				<Typography
					sx={{
						padding: "10px",
						fontSize: "20px",
						fontWeight: "medium",
						textAlign: "center",
						color: theme.palette.text.primary,
					}}
				>
					No shipments are available
				</Typography>
			) : (
				<Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
					<Box sx={{ overflow: "auto", position: "relative" }}>
						<Table
							aria-label="collapsible table"
							stickyHeader
							sx={{ tableLayout: "fixed", width: "100%" }}
						>
							<TableHead>
								<TableRow>
									{columns.map((column, columnIndex) => {
										const isFirstColumn = columnIndex === 0;
										return (
											<TableCell
												key={column.id}
												sx={{
													fontWeight: "bold",
													width: column.width,
													backgroundColor: theme.palette.background.paper,
													zIndex: 1,
													padding: "4px",
													borderBottom: `1px solid ${theme.palette.divider}`,
													textAlign: isFirstColumn ? "center" : "left",
													fontSize: "12px",
												}}
											>
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														justifyContent: isFirstColumn ? "center" : "flex-start",
													}}
												>
													<span>{column.label}</span>
													{column.sortable && (
														<ArrowDownwardOutlinedIcon
															sx={{
																color: isSorting ? "#ccc" : "#006098",
																fontSize: "16px",
																cursor: isSorting ? "not-allowed" : "pointer",
																transform:
																	sortBy === column.id && sortOrder === "ascending"
																		? "rotate(180deg)"
																		: "rotate(0deg)",
																marginLeft: "4px",
															}}
															onClick={() => !isSorting && handleSort(column.id)}
														/>
													)}
												</Box>
											</TableCell>
										);
									})}
								</TableRow>
							</TableHead>
						</Table>
					</Box>
					<Box
						sx={{ overflowY: "auto", overflowX: "hidden", flex: 1, minHeight: 0 }}
						id="scrollableDiv"
					>
						<InfiniteScroll
							dataLength={rows.length}
							next={() => fetchData(false)}
							hasMore={hasMore}
							loader={
								<Typography sx={{ textAlign: "center", padding: "16px" }}>Loading...</Typography>
							}
							scrollableTarget="scrollableDiv"
							initialLoad={false}
						>
							<Table sx={{ tableLayout: "fixed", width: "100%" }}>
								<TableBody>
									{rows.map((row, index) => (
										<Row
											key={`${row.DeliveryNumber}-${index}`}
											row={row}
											handleCustNotesSubmit={handleCustNotesSubmit}
											index={index}
											columns={columns}
										/>
									))}
								</TableBody>
							</Table>
						</InfiniteScroll>
					</Box>
					{rows.length > 0 && (
						<Typography sx={{ textAlign: "center", padding: "4px", fontSize: ".75rem" }}>
							Showing {rows.length} of {totalCount} shipments
						</Typography>
					)}
				</Box>
			)}
			{isLoading && rows.length === 0 && (
				<Typography sx={{ textAlign: "center", padding: "16px" }}>Loading...</Typography>
			)}
		</Paper>
	);
}
